<template>
  <div class="text-center">
    <v-dialog
      :value="modalCheckAccoutIsOpen"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      transition="dialog-bottom-transition"
      @click:outside="openCheckAccountModal"
      @keydown.esc="openCheckAccountModal"
      class="text-left"
      width="500"
    >
      <v-card :loading="modalCheckAccoutIsLoading">
        <v-toolbar v-if="$vuetify.breakpoint.xsOnly" flat height="90">
          <Logo />
        </v-toolbar>
        <v-card-title class="justify-space-between mb-2">
          <span class="d-flex align-center">{{ currentTitle }}</span>
          <v-btn
            @click="openCheckAccountModal"
            v-if="$vuetify.breakpoint.smAndUp"
            class="ma-2"
            text
            icon
            color="lighten-2"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <!-- LOGIN (ID: 1)  -->
        <v-window v-model="step">
          <!-- LOGIN FORM (ID: 2)  -->
          <v-window-item :value="1">
            <v-card-text>
              <v-form ref="checkAccountForm" lazy-validation>
                <v-text-field
                  label="Matrícula"
                  color="#000000"
                  style="color: #00D318 !important; font-color: black !important;"
                  placeholder="Insira sua matrícula"
                  v-model="username"
                  :rules="[v => !!v || 'Preencha o usuário']"
                  outlined
                  required
                  tabindex="1"
                  ref="inputUsername"
                ></v-text-field>
                <v-row justify="start" class="pl-3 mb-5">
                  <v-col cols="10" class="pa-0">
                    <img :src="captchaImageUrl" width="100%" height="50px" />
                  </v-col>
                  <v-col cols="2" class="pa-0">
                    <v-btn
                      @click="getCaptcha"
                      class="ma-2"
                      text
                      icon
                      color="black lighten-2"
                      tabindex="4"
                    >
                      <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-text-field
                  label="Captcha"
                  placeholder="Insira o texto do Captcha"
                  color="#000000"
                  style="color: #00D318 !important; font-color: black !important;"
                  v-model="captcha"
                  :rules="[v => !!v || 'Preencha o captcha']"
                  outlined
                  required
                  tabindex="2"
                  v-on:keyup.enter="identifyUser"
                ></v-text-field>
                <v-btn
                  width="100%"
                  class="py-3"
                  x-large
                  color="#00D318"
                  :disabled="!username || !captcha"
                  @click="identifyUser"
                  tabindex="3"
                >Analisar Conta</v-btn>
                <v-btn
                  width="100%"
                  class="py-3 mt-4"
                  x-large
                  @click="openCheckAccountModal"
                  v-if="$vuetify.breakpoint.xsOnly"
                >Cancelar</v-btn>
              </v-form>
            </v-card-text>
          </v-window-item>

          <!-- RESULTADO ANALISE: SENHA EXPIRADA (PARTE 1 - AVISO) (ID: 2)  -->
          <v-window-item :value="2">
            <v-card-text class="tokenSmsCard">
              <div class="text-center">
                <v-icon size="140" color="primary">mdi-exclamation</v-icon>
                <h2 class="mb-3">Senha Expirada</h2>
                <p>Clique no botão abaixo para prorrograr sua senha por 48h.</p>
              </div>
              <v-btn
                width="100%"
                class="mt-5"
                depressed
                x-large
                color="primary"
                @click="requestTokenSms"
              >Continuar</v-btn>
              <v-btn
                width="100%"
                class="mt-5"
                depressed
                x-large
                @click="openCheckAccountModal"
              >Fechar</v-btn>
            </v-card-text>
          </v-window-item>

          <!-- RESULTADO: SENHA EXPIRADA (PARTE 2 - TOKEN SMS) (ID: 2)  -->
          <v-window-item :value="3">
            <v-card-text class="checkAccountContent tokenSmsCard px-6">
              <div class="text-left">
                <p>Token enviado para o número {{ this.user.phone }}</p>
                <p
                  v-if="smsAgainClicked"
                  class="text-left"
                >Caso esse não seja seu número, atualize seu cadastro no NDS.</p>
              </div>

              <v-text-field
                label="Token SMS"
                placeholder="Insira o token"
                v-model="token"
                :rules="[v => !!v || 'Preencha o token']"
                outlined
                required
              ></v-text-field>

              <v-btn
                width="100%"
                class="mt-5"
                depressed
                x-large
                color="primary"
                @click="verifySms"
                :disabled="!token"
              >Enviar</v-btn>

              <v-btn
                width="100%"
                class="mt-5"
                depressed
                x-large
                color="primary"
                :disabled="counting"
                :loading="loadingSmsAgainButton"
                @click="requestTokenSmsAgain"
              >
                <countdown
                  v-if="counting && !smsAgainClicked"
                  :time="timeSms"
                  @end="handleCountdownEnd"
                >
                  <template slot-scope="props">Pedir outro SMS em {{ props.totalSeconds }}s</template>
                </countdown>

                <span v-if="counting && smsAgainClicked">SMS enviado novamente!</span>

                <span v-if="!counting">Não recebeu o SMS?</span>
              </v-btn>

              <v-btn
                width="100%"
                class="mt-5"
                depressed
                x-large
                @click="openCheckAccountModal"
              >Fechar</v-btn>
            </v-card-text>
          </v-window-item>

          <!-- Login Desabilitado (ID: 4)  -->
          <v-window-item :value="4">
            <v-card-text class="checkAccountContent">
              <v-icon size="140" color="primary">mdi-close</v-icon>
              <h2>Login Desabilitado!</h2>
              <p>Favor entrar em contato com o 0800 282 0031</p>
              <v-btn
                width="100%"
                class="mt-5"
                depressed
                x-large
                color="primary"
                @click="openCheckAccountModal"
              >Fechar</v-btn>
            </v-card-text>
          </v-window-item>

          <!-- Conta Bloqueada (ID: 5)  -->
          <v-window-item :value="5">
            <v-card-text class="checkAccountContent">
              <v-icon size="140" color="primary">mdi-cancel</v-icon>
              <h2>Conta bloqueada!</h2>
              <p>Clique no botão abaixo para desbloquea-la.</p>
              <v-btn
                width="100%"
                class="mt-5"
                depressed
                x-large
                color="primary"
                @click="unlockAccount"
              >Desbloquear Conta</v-btn>
              <v-btn
                width="100%"
                class="mt-5"
                depressed
                x-large
                @click="openCheckAccountModal"
              >Fechar</v-btn>
            </v-card-text>
          </v-window-item>

          <!-- SUCESSO (ID: 0)  -->
          <v-window-item :value="0">
            <v-card-text class="checkAccountContent">
              <v-icon size="140" color="primary">mdi-check</v-icon>
              <h2>Sucesso!</h2>
              <p>Solicitação realizada com sucesso</p>
              <v-alert color="primary" dark outlined class="mt-10">
                Caso o erro ainda persista, favor ligar no
                <strong>0800 282 0031</strong>
              </v-alert>
              <v-btn
                width="100%"
                class="mt-5"
                depressed
                x-large
                color="primary"
                @click="openCheckAccountModal"
              >Fechar</v-btn>
            </v-card-text>
          </v-window-item>

          <!-- ERRO (ID: -1)  -->
          <v-window-item :value="-1">
            <v-card-text class="checkAccountContent">
              <v-icon size="140" color="primary">mdi-close</v-icon>
              <h2>Algo deu errado!</h2>
              <p>Por favor, tente novamente mais tarde.</p>
              <v-btn
                width="100%"
                class="mt-5"
                depressed
                x-large
                color="primary"
                @click="openCheckAccountModal"
              >Fechar</v-btn>
            </v-card-text>
          </v-window-item>

          <!-- ERROR CUSTOM PARA EXTEND PASSWORD (ID: -2)  -->
          <v-window-item :value="-2">
            <v-card-text class="checkAccountContent">
              <v-icon size="140" color="primary">mdi-exclamation</v-icon>
              <h2>Atenção</h2>
              <p>{{ errorFromExtendPassword }}</p>
              <v-alert color="primary" dark outlined class="mt-10">
                Caso o erro ainda persista, favor ligar no
                <strong>0800 282 0031</strong>
              </v-alert>
              <v-btn
                width="100%"
                class="mt-5"
                depressed
                x-large
                color="primary"
                @click="openCheckAccountModal"
              >Fechar</v-btn>
            </v-card-text>
          </v-window-item>

          <!-- SEM ERROS NA ANÁLISE -->
          <v-window-item :value="-3">
            <v-card-text class="checkAccountContent">
              <v-icon size="140" color="primary">mdi-check</v-icon>
              <h2>Sucesso!</h2>
              <p>Não foram encontrados problemas na sua conta</p>
              <v-btn
                width="100%"
                class="mt-5"
                depressed
                x-large
                color="primary"
                @click="openCheckAccountModal"
              >Fechar</v-btn>
            </v-card-text>
          </v-window-item>
        </v-window>

        <v-snackbar v-model="snackbar" multi-line color="error" top>
          {{ snackbarMessage }}
          <v-btn @click="snackbar = false" dark>Close</v-btn>
        </v-snackbar>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import AccountService from "../services/account_service";
import Logo from "./Logo";

export default {
  data: () => {
    return {
      step: 1,
      analisysSuccess: false,
      analisysFailed: false,
      username: "",
      captcha: "",
      token: "",
      counting: true,
      smsAgainClicked: false,
      loadingSmsAgainButton: false,
      timeSms: 20000,
      smsWasValidated: false,
      errorFromExtendPassword: "",
      snackbar: false,
      snackbarMessage: "Ocorreu um erro! Tente novamente mais tarde"
    };
  },
  components: {
    Logo
  },
  computed: {
    ...mapState(["modalCheckAccoutIsOpen"]),
    ...mapState(["modalCheckAccoutIsLoading"]),
    ...mapState(["captchaImageUrl"]),
    ...mapState(["user"]),
    currentTitle() {
      switch (this.step) {
        case 2:
          return "Resultado da análise de conta";
        case 3:
          return "Senha Expirada: Prorrogação";
        default:
          return "Outros problemas?";
      }
    }
  },
  methods: {
    ...mapActions(["openCheckAccountModal"]),
    ...mapActions(["loadingCheckAccountModal"]),
    ...mapActions(["getCaptcha"]),
    ...mapActions(["saveUserInState"]),
    ...mapActions(["saveAccessTokenInUserState"]),
    identifyUser() {
      this.loadingCheckAccountModal();
      setTimeout(() => {
        AccountService.accountAnalysis(this.username, this.captcha)
          .then(response => {
            this.saveUserInState(response.data.result.user);
            this.saveAccessTokenInUserState(response.data.result.accessToken);
            if (this.user.loginDisabled) {
              this.step = 4;
              return;
            }
            if (this.user.lockedByIntruder) {
              this.step = 5;
              return;
            }
            if (this.user.statusPassword === 3) {
              this.step = 2;
              return;
            }
            this.step = -3;
          })
          .catch(err => {
            if (err) {
              this.snackbar = true;
              if (err.response.data.message) {
                this.snackbarMessage = err.response.data.message;
              }
              this.getCaptcha();
            }
            if (this.$refs.checkAccountForm) {
              this.$refs.checkAccountForm.reset();
            }
          });
        this.loadingCheckAccountModal();
      }, 2000);
    },
    unlockAccount() {
      this.loadingCheckAccountModal();
      setTimeout(() => {
        AccountService.unlockAccount(this.user.accessToken)
          .then(response => {
            if (response.data.success) {
              this.step = 0;
              this.loadingCheckAccountModal();
            }
          })
          .catch(err => {
            if (err) {
              this.step = -1;
              this.loadingCheckAccountModal();
            }
          });
      }, 2000);
    },
    requestTokenSms() {
      this.counting = true;
      AccountService.requestTokenForExtendPassword(this.user.accessToken)
        .then(response => {
          if (response.data.success) {
            this.step = 3;
          }
        })
        .catch(err => {
          if (err) {
            this.step = -1;
          }
        });
    },
    requestTokenSmsAgain() {
      this.counting = true;
      this.smsAgainClicked = true;
      this.loadingSmsAgainButton = true;
      setTimeout(() => {
        AccountService.requestTokenForExtendPassword(this.user.accessToken)
          .then(response => {
            if (response.data.success) {
              return true;
            }
          })
          .catch(err => {
            if (err) {
              return false;
            }
          });
        this.loadingSmsAgainButton = false;
      }, 2000);
    },
    handleCountdownEnd: function() {
      this.counting = false;
    },
    verifySms() {
      this.loadingCheckAccountModal();
      setTimeout(() => {
        AccountService.verifySmsToken(this.token, this.user.accessToken)
          .then(response => {
            if (response.data.success) {
              this.smsWasValidated = true;
            }
          })
          .catch(err => {
            if (err) {
              this.step = -1;
            }
          });
        this.loadingCheckAccountModal();
      }, 2000);
    }
  },
  watch: {
    modalCheckAccoutIsOpen: function() {
      this.step = 1;
      if (this.$refs.checkAccountForm) {
        this.$refs.checkAccountForm.reset();
      }
      setTimeout(() => {
        this.$refs.inputUsername.focus();
      }, 10);
    },
    smsWasValidated: function() {
      AccountService.extendPassword(this.user.accessToken)
        .then(response => {
          if (response) {
            this.step = 0;
          }
        })
        .catch(err => {
          if (err) {
            this.errorFromExtendPassword = err.response.data.message;
            // Tela de erro custom
            this.step = -2;
          }
        });
    }
  },
  mounted: function() {
    this.getCaptcha();
  }
};
</script>

<style lang="scss">
.checkAccountContent {
  min-height: 315px;
  text-align: center;
}

.tokenSmsCard {
  p {
    font-size: 16px;
  }
}

.v-label {
  color: #00D318 !important;
}

label {
  color: #00D318 !important;
}
</style>
